import logo from './logo.png';

const Logo = () => <img alt='SciLeads Logo' src={logo} />;

export default Logo;
